import { ExpressionItem } from "./expression-item";

export class Expression {
    id: number;
    name: string;
    title: string;
    size: string;
    calc: boolean = true;
    type: string;
    dataType: string;
    options?: { label: string; value: any }[];
    multiple?: boolean;
    expressionItem: ExpressionItem[];
    placementOrder: number;
}
